"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditableCell = exports.BudgetLineTable = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var antd_1 = require("antd");
var currenciesList_1 = require("common/global/currenciesList");
var projectsList_1 = require("common/global/projectsList");
var unitsList_1 = require("common/global/unitsList");
var firebase_1 = __importDefault(require("firebase"));
var lodash_1 = require("lodash");
var map_1 = __importDefault(require("lodash/map"));
var index_modules_css_1 = __importDefault(require("portal/index.modules.css"));
var hasProjectPermission_1 = require("portal/pages/Projects/hasProjectPermission");
var formatNumber_1 = __importDefault(require("portal/utils/formatNumber"));
var react_1 = __importStar(require("react"));
var auth_1 = require("react-firebase-hooks/auth");
var react_i18next_1 = require("react-i18next");
var AddFromTemplateDialog_1 = __importDefault(require("../Dialogs/AddFromTemplateDialog"));
var BudgetLineItemsTable_1 = require("./BudgetLineItemsTable");
var react_router_dom_1 = require("react-router-dom");
var Option = antd_1.Select.Option;
var TextArea = antd_1.Input.TextArea;
var BudgetLineTable = function (props) {
    var _a, _b;
    var data = props.data, budgetSectionId = props.budgetSectionId, projectId = props.projectId;
    var t = (0, react_i18next_1.useTranslation)().t;
    var user = (0, auth_1.useAuthState)(firebase_1.default.auth())[0];
    var navigate = (0, react_router_dom_1.useNavigate)();
    var _c = (0, react_1.useState)([]), selectedRowKeys = _c[0], setSelectedRowKeys = _c[1];
    var _d = (0, react_1.useState)(""), editingKey = _d[0], setEditingKey = _d[1];
    var _e = (0, react_1.useState)({}), editingState = _e[0], setEditingState = _e[1];
    var _f = (0, react_1.useState)(false), isAdding = _f[0], setIsAdding = _f[1];
    var isTemplate = projectId === "template";
    var _g = (0, react_1.useState)(false), modalState = _g[0], setModalState = _g[1];
    var project = projectsList_1.globalProjectsData[projectId];
    var projectStatus = (project === null || project === void 0 ? void 0 : project.status) || "planning";
    var projectCurrency = (_b = (_a = currenciesList_1.globalCurrenciesData[project === null || project === void 0 ? void 0 : project.currencyId]) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : "";
    // const [budgetLineItemsSnapshot] = useCollection(
    //   budgetLineItemsRef.where("projectId", "==", projectId)
    // );
    // const budgetLineItems = useMemo(
    //   () =>
    //     (budgetLineItemsSnapshot?.docs ?? []).map((e) => {
    //       return {
    //         ...(e.data() as BudgetLineItem),
    //         id: e.id,
    //       };
    //     }),
    //   [budgetLineItemsSnapshot]
    // );
    var save = function (record) {
        var newData = __assign(__assign({}, record), editingState);
        var totalLine = notNaN(parseFloat(newData.durationRecurrence + "") *
            parseFloat(newData.quantity + "") *
            parseFloat(newData.unitCost + "") *
            (parseFloat(newData.allocation + "") / 100));
        // const id = newData.id === "newDoc" ? budgetLinesRef.doc().id : newData.id;
        // budgetLinesRef.doc(id).set({
        //   code: newData.code,
        //   projectId: newData.projectId,
        //   budgetSectionId: newData.budgetSectionId,
        //   unitId: newData.unitId,
        //   description: newData.description,
        //   durationRecurrence: parseFloat(newData.durationRecurrence + ""),
        //   quantity: parseFloat(newData.quantity + ""),
        //   unitCost: parseFloat(newData.unitCost + ""),
        //   allocation: parseFloat(newData.allocation + ""),
        //   total: totalLine,
        //   type: newData.type,
        //   createdAt: new Date() as any,
        //   updatedAt: new Date() as any,
        // });
        setEditingKey("");
        setIsAdding(false);
    };
    function InsertIRItems() {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/];
            });
        });
    }
    var columnsBudgetLine = [
        {
            title: "Code",
            dataIndex: "code",
            key: "code",
            editable: true,
        },
        {
            title: "Description",
            dataIndex: "description",
            key: "description",
            editable: true,
        },
        { title: "Type", dataIndex: "type", key: "type", editable: true },
        {
            title: "Unit",
            dataIndex: "unitId",
            key: "unitId",
            editable: true,
            render: function (_, _a) {
                var _b;
                var unitId = _a.unitId;
                return (_b = unitsList_1.globalUnitsData[unitId]) === null || _b === void 0 ? void 0 : _b.name;
            },
        },
        {
            title: "Unit Quantity",
            dataIndex: "quantity",
            key: "quantity",
            editable: true,
        },
        {
            title: "Unit Cost",
            dataIndex: "unitCost",
            key: "unitCost",
            editable: true,
        },
        {
            title: "Duration",
            dataIndex: "durationRecurrence",
            key: "durationRecurrence",
            editable: true,
        },
        {
            title: "Allocation",
            dataIndex: "allocation",
            key: "allocation",
            editable: true,
            render: function (allocation) { return "".concat(allocation, "%"); },
        },
        {
            title: "Total Cost",
            dataIndex: "total",
            key: "total",
            editable: true,
            render: function (_, record) {
                var editing = editingKey === record.id;
                var finalData = editing ? __assign(__assign({}, record), editingState) : record;
                return (0, formatNumber_1.default)(notNaN(parseFloat(finalData.quantity + "") *
                    parseFloat(finalData.unitCost + "") *
                    (parseFloat(finalData.allocation + "") / 100) *
                    parseFloat(finalData.durationRecurrence + "")));
            },
        },
        {
            title: "operation",
            dataIndex: "operation",
            render: function (_, record) {
                return record.id === editingKey ? ((0, jsx_runtime_1.jsxs)("span", { children: [(0, jsx_runtime_1.jsx)(antd_1.Button, __assign({ type: "link", onClick: function () {
                                save(record);
                            }, style: { marginRight: 8 } }, { children: t("common.save") })), (0, jsx_runtime_1.jsx)(antd_1.Popconfirm, __assign({ title: "Sure to cancel?", onConfirm: function () {
                                setEditingKey("");
                                setIsAdding(false);
                            } }, { children: (0, jsx_runtime_1.jsx)(antd_1.Button, __assign({ type: "link" }, { children: t("common.cancel") })) }))] })) : ((0, jsx_runtime_1.jsx)(antd_1.Button, __assign({ type: "link", disabled: projectStatus !== "planning", onClick: function () {
                        setEditingKey(record.id);
                        setEditingState({});
                    } }, { children: t("common.edit") })));
            },
        },
    ];
    var expandedRowRender = function (row, index) {
        return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(BudgetLineItemsTable_1.BudgetLineItemsTable, { budgetLineId: row.id, budgetSectionId: budgetSectionId, index: index, code: row.code, projectId: projectId }), projectStatus === "running" &&
                    (0, hasProjectPermission_1.hasProjectPermission)(projectId, ["IRCreate"]) ? ((0, jsx_runtime_1.jsxs)("div", __assign({ className: index_modules_css_1.default.buttonsGroup }, { children: [(0, jsx_runtime_1.jsx)(antd_1.Button, __assign({ onClick: InsertIRItems, disabled: !hasSelected }, { children: t("budget.createIR") })), (0, jsx_runtime_1.jsx)("span", __assign({ style: { marginLeft: 8 } }, { children: hasSelected ? "Selected ".concat(selectedRowKeys.length, " items") : "" }))] }))) : null] }));
    };
    var handleAdd = function () {
        var _a, _b;
        var budgetLineId = "newDoc";
        var newObj = {
            projectId: projectId,
            budgetSectionId: budgetSectionId,
            id: budgetLineId,
            code: "",
            unitCost: 0,
            quantity: 1,
            total: 0,
            allocation: 100,
            durationRecurrence: 1,
            type: "delivery",
            description: "",
            unitId: (_b = (_a = (0, lodash_1.sample)(unitsList_1.globalUnitsData)) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : null,
            createdAt: new Date(),
        };
        setEditingState(newObj);
        setIsAdding(true);
        setEditingKey(budgetLineId);
    };
    var deleteBudgetLine = (0, react_1.useCallback)(function () {
        // selectedRowKeys.forEach((docId) => {
        //   budgetLineItems
        //     .filter((e) => e.budgetLineId === docId)
        //     .map((x) => x.id)
        //     .forEach((itemDoc) => {
        //       budgetLineItemsRef.doc(itemDoc).delete();
        //     });
        //   budgetLinesRef
        //     .doc(docId)
        //     .delete()
        //     .then(() => {
        //       setSelectedRowKeys([]);
        //     });
        // });
    }, [
        // budgetLineItems,
        selectedRowKeys,
    ]);
    if (
    // !budgetLineItemsSnapshot ||
    !data) {
        return (0, jsx_runtime_1.jsx)(antd_1.Spin, {});
    }
    var hasSelected = selectedRowKeys.length > 0;
    var columns = columnsBudgetLine.map(function (col) {
        if (!col.editable) {
            return col;
        }
        return __assign(__assign({}, col), { onCell: function (record) {
                var editing = editingKey === record.id;
                var finalData = editing ? __assign(__assign({}, record), editingState) : record;
                var recordValue = finalData[col.dataIndex];
                if (col.dataIndex === "total") {
                    recordValue = (0, formatNumber_1.default)(notNaN(parseFloat(finalData.quantity + "") *
                        parseFloat(finalData.unitCost + "") *
                        (parseFloat(finalData.allocation + "") / 100) *
                        parseFloat(finalData.durationRecurrence + "")));
                    editing = false;
                }
                else if (col.dataIndex === "allocation") {
                    if (!editing) {
                        recordValue = "".concat(recordValue, "%");
                    }
                }
                var inputType = {
                    index: "index",
                    type: "select",
                    unitId: "unitSelect",
                    description: "description",
                    quantity: "number",
                    unitCost: "number",
                    allocation: "percentage",
                    durationRecurrence: "number",
                };
                return {
                    record: record,
                    inputType: inputType[col.dataIndex] || "text",
                    dataIndex: col.dataIndex,
                    title: col.title,
                    editing: editing,
                    value: recordValue,
                    onChangeText: function (newValue) {
                        var _a;
                        setEditingState(__assign(__assign({}, editingState), (_a = {}, _a[col.dataIndex] = newValue, _a)));
                    },
                    onChangeRecord: function (newRecord) {
                        setEditingState(__assign(__assign({}, editingState), newRecord));
                    },
                };
            } });
    });
    var totalBudgetLinesDoc = (0, formatNumber_1.default)((0, lodash_1.sum)(data.map(function (e) { return e.total; })));
    var dataSource = isAdding ? __spreadArray(__spreadArray([], data, true), [editingState], false) : data;
    var totalBudgetLines = "Total:  ".concat(totalBudgetLinesDoc, " ").concat(projectCurrency);
    return ((0, jsx_runtime_1.jsxs)(react_1.default.Fragment, { children: [(0, jsx_runtime_1.jsx)(AddFromTemplateDialog_1.default, { modalState: modalState, setModalState: setModalState, budgetSectionId: budgetSectionId, projectId: projectId }), (0, jsx_runtime_1.jsx)("div", __assign({ className: index_modules_css_1.default.tables }, { children: (0, jsx_runtime_1.jsx)(antd_1.Table, { rowKey: "id", components: {
                        body: {
                            cell: exports.EditableCell,
                        },
                    }, columns: columns, rowSelection: {
                        onChange: function (selectedRow, selectedRows) {
                            setSelectedRowKeys(selectedRows.map(function (x) { return x.id; }));
                        },
                    }, dataSource: dataSource, expandedRowRender: expandedRowRender, pagination: false, showHeader: true, size: "small", title: function () { return ((0, jsx_runtime_1.jsx)("div", { children: projectStatus === "planning" ? ((0, jsx_runtime_1.jsxs)("div", __assign({ className: index_modules_css_1.default.buttonsGroup }, { children: [(0, jsx_runtime_1.jsxs)(antd_1.Button, __assign({ onClick: handleAdd }, { children: [" ", t("budget.addNewLine")] })), (0, jsx_runtime_1.jsx)(antd_1.Button, __assign({ onClick: deleteBudgetLine, disabled: !hasSelected }, { children: t("common.delete") })), (0, jsx_runtime_1.jsx)("span", __assign({ style: { marginLeft: 8 } }, { children: hasSelected
                                        ? "Selected ".concat(selectedRowKeys.length, " items")
                                        : "" })), isTemplate ? null : ((0, jsx_runtime_1.jsx)(antd_1.Button, __assign({ onClick: function () { return setModalState(true); }, style: { float: "right" } }, { children: t("budget.addFromTemplates") })))] }))) : null })); }, footer: function () { return ((0, jsx_runtime_1.jsx)("h3", __assign({ style: {
                            background: "#fff",
                            padding: 20,
                            borderRadius: 5,
                            display: "flex",
                            justifyContent: "flex-end",
                        } }, { children: (0, jsx_runtime_1.jsx)("b", { children: totalBudgetLines }) }))); } }) }))] }));
};
exports.BudgetLineTable = BudgetLineTable;
var EditableCell = function (props) {
    var t = (0, react_i18next_1.useTranslation)().t;
    var editing = props.editing, dataIndex = props.dataIndex, inputType = props.inputType, record = props.record, children = props.children, value = props.value, restProps = __rest(props, ["editing", "dataIndex", "inputType", "record", "children", "value"]);
    var getInput = function () {
        switch (inputType) {
            case "select": {
                return ((0, jsx_runtime_1.jsxs)(antd_1.Select, __assign({ value: record[dataIndex], onChange: function (e) { return props.onChangeText(e); }, style: { minWidth: 100 } }, { children: [(0, jsx_runtime_1.jsx)(Option, __assign({ value: "delivery" }, { children: t("common.delivery") })), (0, jsx_runtime_1.jsx)(Option, __assign({ value: "service" }, { children: t("common.service") }))] })));
            }
            case "unitSelect": {
                return ((0, jsx_runtime_1.jsx)(antd_1.Select, __assign({ style: { minWidth: 200 }, showSearch: true, optionFilterProp: "children", value: props.value, onChange: function (e) {
                        props.onChangeRecord({ unitId: e });
                    } }, { children: (0, map_1.default)(unitsList_1.globalUnitsData, function (unit) {
                        return ((0, jsx_runtime_1.jsx)(Option, __assign({ value: unit.id }, { children: unit.name }), unit.id));
                    }) })));
            }
            case "textArea": {
                return ((0, jsx_runtime_1.jsx)(TextArea, { value: value, onChange: function (e) { return props.onChangeText(e.target.value); } }));
            }
            case "number": {
                return ((0, jsx_runtime_1.jsx)(antd_1.InputNumber, { min: 0, type: "number", value: value, onChange: function (e) { return props.onChangeText(e); } }));
            }
            case "percentage": {
                return ((0, jsx_runtime_1.jsx)(antd_1.InputNumber, { min: 0, max: 100, formatter: function (v) { return "".concat(v, "%"); }, parser: function (value) { return notNaN(parseFloat(value.replace("%", ""))); }, value: value, onChange: function (e) {
                        return props.onChangeText(notNaN(Number.parseInt(e.toString())));
                    } }));
            }
        }
        return ((0, jsx_runtime_1.jsx)(antd_1.Input, { value: value, onChange: function (e) { return props.onChangeText(e.target.value); }, style: { minWidth: 60 } }));
    };
    return ((0, jsx_runtime_1.jsx)("td", __assign({}, restProps, { children: editing ? ((0, jsx_runtime_1.jsx)(antd_1.Form.Item, __assign({ style: { margin: 0 } }, { children: getInput() }))) : dataIndex === "unitId" ? (children) : (value !== null && value !== void 0 ? value : children) })));
};
exports.EditableCell = EditableCell;
function notNaN(num, otherwise) {
    if (otherwise === void 0) { otherwise = 0; }
    return isNaN(num) ? otherwise : num;
}
